require('./angular-messages');
module.exports = 'ngMessages';



//////////////////
// WEBPACK FOOTER
// ../~/angular-messages/index.js
// module id = 374
// module chunks = 0